import React, { useEffect, useState } from "react"
import "./nfStyle.css"
import { getCommentForEachMessage } from "./utils"
import { createRecord } from "services/quickblox"
import { ReactComponent as SendIcon } from "../../assets/images/inbox/send_black.svg";

export default function CommentSection(props) {
  const { getInitials, messageId, authUser } = props
  const [isActive, setIsActive] = useState(false)
  const [comments, setComments] = useState([])
  const [commentInput, setCommentInput] = useState("")

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsActive(true)
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    async function fetchComments() {
      if (messageId) {
        const data = await getCommentForEachMessage(messageId)
        setComments(data)
      }
    }
    fetchComments()
  }, [messageId])

  const postComment = async () => {
    if (commentInput?.trim()?.length) {
      const data = {
        text: commentInput,
        sender_id: authUser?.id,
        parent_message_id: messageId,
      }
      const comment = await createRecord("Comments", data)
      setCommentInput("")
      setComments(prevState => [
        ...prevState,
        { ...comment, profile: authUser },
      ])
    }
  }

  return (
    <div className={`message-list ${isActive ? "active" : ""}`}>
      {comments?.length > 0 ? (
        comments
          .sort((a, b) => new Date(b.date) - new Date(a.date))
          .map(comment => {
            return (
              <div className="message" key={comment.id}>
                {comment?.profile?.profile_pic?.file?.url ? (
                  <div className="avatar">
                    <img
                      src={comment?.profile?.profile_pic?.file?.url}
                      alt="Avatar"
                    />
                  </div>
                ) : (
                  <div className="initial-character direct-messages-in me-3 rounded-circle">
                    <h4 className="m-0 p-0">
                      {getInitials(
                        `${comment?.profile?.first_name} + ${comment?.profile?.last_name}`
                      )}
                    </h4>
                  </div>
                )}
                <div className="message-details">
                  <div className="name-and-date">
                    <span className="name">{`${comment?.profile?.first_name} ${comment?.profile?.last_name}`}</span>
                    <span className="date">
                      {new Date(comment?.date).toLocaleString("en-GB", {
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </span>
                  </div>
                  <div className="message-preview">{comment?.text}</div>
                </div>
              </div>
            )
          })
      ) : (
        <div className="no-comments" style={{ marginLeft: "44px" }}>
          <br />
          <strong>No comments yet</strong>
        </div>
      )}

      <footer className="news-feed-card-footer">
        {authUser?.profile_pic?.file?.url ? (
          <div className="user-avatar">
            <img src={authUser?.profile_pic?.file?.url} alt="User avatar" />
          </div>
        ) : (
          <div className="initial-character direct-messages-in me-3 rounded-circle">
            <h4 className="m-0 p-0">
              {getInitials(`${authUser?.first_name} + ${authUser?.last_name}`)}
            </h4>
          </div>
        )}

        <input
          type="text"
          className="message-input"
          placeholder="Write your comment"
          value={commentInput}
          onChange={e => {
            setCommentInput(e.target.value)
          }}
          onKeyDown={e => {
            if (e.key === "Enter") {
              postComment()
              e.preventDefault()
            }
          }}
        />
        <button
          className="btn-rounded-sm"
          style={{ backgroundColor: "rgb(255, 255, 255)" }}
          onClick={postComment}
        >
          <SendIcon />
        </button>
      </footer>
    </div>
  )
}
